module.exports = __webpack_public_path__ + "img/observer.a17d9757.svg";